<template>
    <div class="app-wrapper">
        <nav-bar />
        <!-- <slider-bar /> -->
        <app-main />
        <AppFooter />
    </div>
</template>

<script>
import NavBar from './components/NavBar.vue'
import SliderBar from './components/SliderBar.vue'
import AppMain  from './components/AppMain.vue'
import AppFooter from './components/AppFooter.vue'
export default {
    components: {
        NavBar,
        SliderBar,
        AppMain,
        AppFooter
    }
}
</script>

<style lang="scss" scoped>
.app-wrapper {
    height: 100%;
    box-sizing: border-box;
    padding-top: 64px;
}
</style>
